import invariant from 'invariant';
import type { Project } from '@frameio/graphql-client/generated';
import { createUrl } from '../helpers/createUrl';
import { getPathnameFromHref } from '../helpers/getPathnameFromHref';
import type { ValidHref } from '../types';

/**
 * UploadLinksPage
 *
 * /project/:projectId/upload-links
 */
type UploadLinksPage = {
  page: 'uploadLinks';
  projectId: Project['id'];
};

export type UploadLinksGetLinkParams = UploadLinksPage;

export const getLinkForUploadLinks = (
  params: UploadLinksGetLinkParams
): ValidHref => {
  invariant(params.projectId, 'projectId is required');

  if (params.page === 'uploadLinks') {
    return createUrl({
      pathname: `/project/${params.projectId}/upload-links`,
    });
  }

  throw new Error('Not implemented');
};

export const isUploadLinksPageType = (href: ValidHref): boolean => {
  const parts = getPathnameFromHref(href).split('/');

  // /project/:projectId/upload-links
  return parts[1] === 'project' && parts[3] === 'upload-links';
};
